import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getCourses } from '../redux/actions/courses';

function Default(props) {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const { courses, coursesLoaded } = props;

  useEffect(() => {
    props.getCourses();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!coursesLoaded) return;
    const accessCourses = courses.filter(c => c.accessible === true);
    if (!accessCourses.length) return setRedirectUrl('/kursy/');
    const currentCourse = props.currentCourseId !== undefined ?
      props.courses.find(course => course.id === props.currentCourseId) : null;
    if (currentCourse) {
      const access = courses.find(c => c.id === currentCourse.id);
      if (access) {
        return setRedirectUrl(`/kurs/${currentCourse.permalink}/cwiczenia/`);
      }
    }
    if (accessCourses.length === 1) {
      const currentCourse = accessCourses[0];
      return setRedirectUrl(`/kurs/${currentCourse.permalink}/cwiczenia/`);
    }
    setRedirectUrl('/kursy/')
    // eslint-disable-next-line
  }, [coursesLoaded]);

  if (!redirectUrl) return '';
  return <Redirect to={redirectUrl} />
}

const mapStateToProps = (state) => {
  return {
    currentCourseId: state.userState.currentCourseId,
    courses: state.courses,
    coursesLoaded: state.config.coursesLoaded,
  }
}

export default connect(mapStateToProps, { getCourses })(Default);
